import React, { useEffect, useState } from 'react';
import { Translate } from '~/i18n';
import Image from '../common/image';

export const CrossHeads = ({ pageName }: any) => {
   const CrossHeadsItems: any[] = [
      {
         title: <Translate id={`tickets:${pageName} crosshead 1`} />,
         description: <Translate id={`tickets:${pageName} crosshead 1 description`} />,
         image: '/images/tickets-page/cross-head-01.svg',
      },
      {
         title: <Translate id={`tickets:${pageName} crosshead 2`} />,
         description: <Translate id={`tickets:${pageName} crosshead 2 description`} />,
         image: '/images/tickets-page/cross-head-02.svg',
      },
      {
         title: <Translate id={`tickets:${pageName} crosshead 3`} />,
         description: <Translate id={`tickets:${pageName} crosshead 3 description`} />,
         image: '/images/tickets-page/cross-head-01.svg',
      },
      {
         title: <Translate id={`tickets:${pageName} crosshead 4`} />,
         description: <Translate id={`tickets:${pageName} crosshead 4 description`} />,
         image: '/images/tickets-page/cross-head-02.svg',
      },
   ];
   const [crossHeadsItems, setCrossHeadsItems] = useState(CrossHeadsItems.length);

   useEffect(() => {
      if (pageName === 'sell-event-tickets-offline') {
         setCrossHeadsItems(3);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return (
      <div className="p-8 mt-6 space-y-12 bg-white shadow-sm rounded-3xl lg:px-20 lg:py-20 lg:space-y-28">
         {CrossHeadsItems?.slice(0, crossHeadsItems).map(({ image, title, description }, index) => {
            const isEven = index % 2 === 0;
            return (
               <div
                  key={index}
                  className={`flex flex-col w-full lg:flex-row ${
                     isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  } gap-10 lg:gap-20 items-center`}>
                  <div className="lg:order-1 lg:w-1/2">
                     <Image src={image} width="481" height="361" />
                  </div>
                  <div className="space-y-4 lg:order-2 lg:flex-1">
                     <div className="text-3xl font-bold lg:text-5xl">{title}</div>
                     <div className="text-lg font-medium text-primary-light lg:text-xl ">
                        {description}
                     </div>
                  </div>
               </div>
            );
         })}
      </div>
   );
};
